export const gridColsVariants = {
  columns: {
    none: 'grid-cols-none',
    subgrid: 'grid-cols-subgrid',
    1: 'grid-cols-[repeat(1,1fr)]',
    2: 'grid-cols-[repeat(2,1fr)]',
    3: 'grid-cols-[repeat(3,1fr)]',
    4: 'grid-cols-[repeat(4,1fr)]',
    5: 'grid-cols-[repeat(5,1fr)]',
    6: 'grid-cols-[repeat(6,1fr)]',
    7: 'grid-cols-[repeat(7,1fr)]',
    8: 'grid-cols-[repeat(8,1fr)]',
    9: 'grid-cols-[repeat(9,1fr)]',
    10: 'grid-cols-[repeat(10,1fr)]',
    11: 'grid-cols-[repeat(11,1fr)]',
    12: 'grid-cols-[repeat(12,1fr)]',
  },

  'columns-xs': {
    none: 'xs:grid-cols-none',
    subgrid: 'xs:grid-cols-subgrid',
    1: 'xs:grid-cols-[repeat(1,1fr)]',
    2: 'xs:grid-cols-[repeat(2,1fr)]',
    3: 'xs:grid-cols-[repeat(3,1fr)]',
    4: 'xs:grid-cols-[repeat(4,1fr)]',
    5: 'xs:grid-cols-[repeat(5,1fr)]',
    6: 'xs:grid-cols-[repeat(6,1fr)]',
    7: 'xs:grid-cols-[repeat(7,1fr)]',
    8: 'xs:grid-cols-[repeat(8,1fr)]',
    9: 'xs:grid-cols-[repeat(9,1fr)]',
    10: 'xs:grid-cols-[repeat(10,1fr)]',
    11: 'xs:grid-cols-[repeat(11,1fr)]',
    12: 'xs:grid-cols-[repeat(12,1fr)]',
  },
  'columns-sm': {
    none: 'sm:grid-cols-none',
    subgrid: 'sm:grid-cols-subgrid',
    1: 'sm:grid-cols-[repeat(1,1fr)]',
    2: 'sm:grid-cols-[repeat(2,1fr)]',
    3: 'sm:grid-cols-[repeat(3,1fr)]',
    4: 'sm:grid-cols-[repeat(4,1fr)]',
    5: 'sm:grid-cols-[repeat(5,1fr)]',
    6: 'sm:grid-cols-[repeat(6,1fr)]',
    7: 'sm:grid-cols-[repeat(7,1fr)]',
    8: 'sm:grid-cols-[repeat(8,1fr)]',
    9: 'sm:grid-cols-[repeat(9,1fr)]',
    10: 'sm:grid-cols-[repeat(10,1fr)]',
    11: 'sm:grid-cols-[repeat(11,1fr)]',
    12: 'sm:grid-cols-[repeat(12,1fr)]',
  },
  'columns-md': {
    none: 'md:grid-cols-none',
    subgrid: 'md:grid-cols-subgrid',
    1: 'md:grid-cols-[repeat(1,1fr)]',
    2: 'md:grid-cols-[repeat(2,1fr)]',
    3: 'md:grid-cols-[repeat(3,1fr)]',
    4: 'md:grid-cols-[repeat(4,1fr)]',
    5: 'md:grid-cols-[repeat(5,1fr)]',
    6: 'md:grid-cols-[repeat(6,1fr)]',
    7: 'md:grid-cols-[repeat(7,1fr)]',
    8: 'md:grid-cols-[repeat(8,1fr)]',
    9: 'md:grid-cols-[repeat(9,1fr)]',
    10: 'md:grid-cols-[repeat(10,1fr)]',
    11: 'md:grid-cols-[repeat(11,1fr)]',
    12: 'md:grid-cols-[repeat(12,1fr)]',
  },
  'columns-lg': {
    none: 'lg:grid-cols-none',
    subgrid: 'lg:grid-cols-subgrid',
    1: 'lg:grid-cols-[repeat(1,1fr)]',
    2: 'lg:grid-cols-[repeat(2,1fr)]',
    3: 'lg:grid-cols-[repeat(3,1fr)]',
    4: 'lg:grid-cols-[repeat(4,1fr)]',
    5: 'lg:grid-cols-[repeat(5,1fr)]',
    6: 'lg:grid-cols-[repeat(6,1fr)]',
    7: 'lg:grid-cols-[repeat(7,1fr)]',
    8: 'lg:grid-cols-[repeat(8,1fr)]',
    9: 'lg:grid-cols-[repeat(9,1fr)]',
    10: 'lg:grid-cols-[repeat(10,1fr)]',
    11: 'lg:grid-cols-[repeat(11,1fr)]',
    12: 'lg:grid-cols-[repeat(12,1fr)]',
  },
  'columns-xl': {
    none: 'xl:grid-cols-none',
    subgrid: 'xl:grid-cols-subgrid',
    1: 'xl:grid-cols-[repeat(1,1fr)]',
    2: 'xl:grid-cols-[repeat(2,1fr)]',
    3: 'xl:grid-cols-[repeat(3,1fr)]',
    4: 'xl:grid-cols-[repeat(4,1fr)]',
    5: 'xl:grid-cols-[repeat(5,1fr)]',
    6: 'xl:grid-cols-[repeat(6,1fr)]',
    7: 'xl:grid-cols-[repeat(7,1fr)]',
    8: 'xl:grid-cols-[repeat(8,1fr)]',
    9: 'xl:grid-cols-[repeat(9,1fr)]',
    10: 'xl:grid-cols-[repeat(10,1fr)]',
    11: 'xl:grid-cols-[repeat(11,1fr)]',
    12: 'xl:grid-cols-[repeat(12,1fr)]',
  },
}
